import {
  SortDirection,
  SortField,
  SortRule,
} from '@epicuro-next/models/order-book';

export const defaultSortMapping: Record<string, SortRule[]> = {
  [`${SortField.OrderNumber}-${SortDirection.Asc}`]: [
    {
      field: SortField.OrderNumber,
      direction: SortDirection.Asc,
    },
  ],
  [`${SortField.OrderNumber}-${SortDirection.Desc}`]: [
    {
      field: SortField.OrderNumber,
      direction: SortDirection.Desc,
    },
  ],
  [`${SortField.PlacedDate}-${SortDirection.Asc}`]: [
    {
      field: SortField.PlacedDate,
      direction: SortDirection.Asc,
    },
    {
      field: SortField.OrderNumber,
      direction: SortDirection.Asc,
    },
  ],
  [`${SortField.PlacedDate}-${SortDirection.Desc}`]: [
    {
      field: SortField.PlacedDate,
      direction: SortDirection.Desc,
    },
    {
      field: SortField.OrderNumber,
      direction: SortDirection.Desc,
    },
  ],
  [`${SortField.RequestedDate}-${SortDirection.Asc}`]: [
    {
      field: SortField.RequestedDate,
      direction: SortDirection.Asc,
    },
    {
      field: SortField.OrderNumber,
      direction: SortDirection.Asc,
    },
  ],
  [`${SortField.RequestedDate}-${SortDirection.Desc}`]: [
    {
      field: SortField.RequestedDate,
      direction: SortDirection.Desc,
    },
    {
      field: SortField.OrderNumber,
      direction: SortDirection.Desc,
    },
  ],
  [`${SortField.ClientReferenceNumber}-${SortDirection.Asc}`]: [
    {
      field: SortField.ClientReferenceNumber,
      direction: SortDirection.Asc,
    },
    {
      field: SortField.OrderNumber,
      direction: SortDirection.Asc,
    },
  ],
  [`${SortField.ClientReferenceNumber}-${SortDirection.Desc}`]: [
    {
      field: SortField.ClientReferenceNumber,
      direction: SortDirection.Desc,
    },
    {
      field: SortField.OrderNumber,
      direction: SortDirection.Desc,
    },
  ],
  [`${SortField.Quantity}-${SortDirection.Asc}`]: [
    {
      field: SortField.Quantity,
      direction: SortDirection.Asc,
    },
    {
      field: SortField.OrderNumber,
      direction: SortDirection.Asc,
    },
  ],
  [`${SortField.Quantity}-${SortDirection.Desc}`]: [
    {
      field: SortField.Quantity,
      direction: SortDirection.Desc,
    },
    {
      field: SortField.OrderNumber,
      direction: SortDirection.Desc,
    },
  ],
  [`${SortField.Value}-${SortDirection.Asc}`]: [
    {
      field: SortField.Value,
      direction: SortDirection.Asc,
    },
    {
      field: SortField.OrderNumber,
      direction: SortDirection.Asc,
    },
  ],
  [`${SortField.Value}-${SortDirection.Desc}`]: [
    {
      field: SortField.Value,
      direction: SortDirection.Desc,
    },
    {
      field: SortField.OrderNumber,
      direction: SortDirection.Desc,
    },
  ],
};

export const defaultSortRule: SortRule = {
  field: SortField.PlacedDate,
  direction: SortDirection.Desc,
};
